import type { Prototype } from "../prototype-types";

export const arthurChePrototypes: Prototype[] = [
  {
    id: "ad-search-results",
    name: "Ad surface: Search Results",
    path: "/ac/ad-search-results",
    description:
      "Brand-level ad modules in the search results grid: full-row rail, vertical spotlight, billboard, repurposed minishop, collage, and single-tile brand ad variants.",
    owner: "Arthur Che",
    createdAt: "2026-04-22",
    lastUpdated: "2026-04-22",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    thumbnail: "/images/thumbnails/ad-search-results.png",
    creationTool: "cursor",
    project: "Ad surface explorations",
  },
  {
    id: "ad-search-box",
    name: "Ad surface: Search Box",
    path: "/ac/ad-search-box",
    description:
      "Ad placements inside the search dropdown: promoted brand chips, sponsored sections, trending product rows, and full-width brand banners across empty and typeahead states.",
    owner: "Arthur Che",
    createdAt: "2026-04-24",
    lastUpdated: "2026-04-24",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    thumbnail: "/images/thumbnails/ad-search-box.png",
    creationTool: "cursor",
    project: "Ad surface explorations",
  },
  {
    id: "ad-brand-page",
    name: "Ad surface: Brand Page",
    path: "/ac/ad-brand-page",
    description:
      "Promoted brand tiles injected into the 'Brands you might like' carousel on a brand page — image and video variants.",
    owner: "Arthur Che",
    createdAt: "2026-04-23",
    lastUpdated: "2026-04-23",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    thumbnail: "/images/thumbnails/ad-brand-page.png",
    creationTool: "cursor",
    project: "Ad surface explorations",
  },
  {
    id: "ad-cart-list",
    name: "Ad surface: Cart List",
    path: "/ac/ad-cart-list",
    description:
      "Compact inline brand ad module inserted between cart items in the multi-brand cart list view.",
    owner: "Arthur Che",
    createdAt: "2026-04-23",
    lastUpdated: "2026-04-23",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    thumbnail: "/images/thumbnails/ad-cart-list.png",
    creationTool: "cursor",
    project: "Ad surface explorations",
  },
  {
    id: "ad-brand-cart",
    name: "Ad surface: Brand Cart",
    path: "/ac/ad-brand-cart",
    description:
      "Ad placements inside a single brand's cart: 'Complete your cart' with promoted tiles, auto-quantity to hit minimum, 'Other brands you might like', and cross-brand product carousels.",
    owner: "Arthur Che",
    createdAt: "2026-04-24",
    lastUpdated: "2026-04-24",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    thumbnail: "/images/thumbnails/ad-brand-cart.png",
    creationTool: "cursor",
    project: "Ad surface explorations",
  },
  {
    id: "ads-2d-controls",
    name: "Ads 2D Controls (Research prototypes)",
    path: "/ac/ads-2d-controls",
    description:
      "Research prototypes exploring 2D controls for ads budget and bidding aggressiveness. Features modal variants (stacked controls, presets) and full-page variants with audience selection and shared/separate spending limits.",
    owner: "Arthur",
    createdAt: "2026-01-15",
    lastUpdated: "2026-01-30",
    surfaceArea: "Brand",
    category: "experimental",
    status: "legacy",
    thumbnail: "/images/thumbnails/ads-2d-controls.png",
    creationTool: "cursor",
  },
  {
    id: "ads-2d-controls-alpha-beta",
    name: "Ads 2D Controls (Alpha + Beta)",
    path: "/ac/ads-2d-controls-alpha-beta",
    description:
      "Alpha/Beta launch prototypes for the Promoted Listings advertising settings page. Features Growth mode with A/B copy test (named labels vs numbered levels) and Monthly budget module with shared/separate audience budgets.",
    owner: "Arthur",
    createdAt: "2026-02-20",
    lastUpdated: "2026-02-20",
    surfaceArea: "Brand",
    category: "experimental",
    status: "legacy",
    thumbnail: "/images/thumbnails/ads-2d-controls-alpha-beta.png",
    creationTool: "cursor",
  },
  {
    id: "video-ad-tiles",
    name: "Video ad tiles",
    path: "/ac/video-ad-tiles",
    description:
      "Promoted product tiles with looping video in the search results grid. Toggles control the max number of video ad tiles, which promoted slot the first video appears in, and the minimum gap between video ad tiles.",
    owner: "Arthur Che",
    createdAt: "2026-07-07",
    lastUpdated: "2026-07-08",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    thumbnail: "/images/thumbnails/video-ad-tiles.png",
    creationTool: "cursor",
    project: "Premium ad formats",
  },
  {
    id: "ac-video-ad-tiles-m0-xp",
    name: "Video Ad Tiles M0 XP",
    path: "/ac/video-ad-tiles-m0-xp",
    description:
      "First-version experiment proposal for video ad tiles: a single premium video ad tile, landing on a random ad slot each page load.",
    owner: "Arthur Che",
    createdAt: "2026-07-23",
    lastUpdated: "2026-07-23",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/07f4bb571bb22889bdde2d29b225dfc06fee96e29f492a1769cc0c446069edb4.png",
    creationTool: "claude-code",
    project: "Premium ad formats",
  },
  {
    id: "ac-product-video-tile-readiness-audit",
    name: "Product Video Tile Readiness Audit",
    path: "/ac/product-video-tile-readiness-audit",
    description:
      "Interactive walkthrough of the top-100 video-backed ad products readiness audit: real playable video product tiles for each tile-readiness classification (tile-ready, needs editing, not suitable), with rationale for why some videos don't work as autoplay tiles.",
    owner: "Arthur Che",
    createdAt: "2026-07-23",
    lastUpdated: "2026-07-23",
    surfaceArea: "Other",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/1999bee0ea12ce6608e826cf04f6460b0be1c6b62f0c7d31aceeb6c11be0e771.png",
    creationTool: "cursor",
    project: "Premium ad formats",
  },
  {
    id: "ac-ad-carousel-homepage",
    name: "Ad Carousel on Homepage",
    path: "/ac/ad-carousel-homepage",
    description: "",
    owner: "Arthur Che",
    createdAt: "2026-08-06",
    lastUpdated: "2026-08-06",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/5e17030cd350249308dc239e5a392c2257e316488e7f65f96754474c2184a759.png",
    creationTool: "cursor",
  },
  {
    id: "ac-video-ad-tiles-homepage",
    name: "Video Ad Tiles on Homepage",
    path: "/ac/video-ad-tiles-homepage",
    description:
      "Autoplay video ad tiles in the Homepage Ideas for you feed, with randomized placement and current-versus-new product tile comparisons.",
    owner: "Arthur Che",
    createdAt: "2026-09-23",
    lastUpdated: "2026-09-23",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/36ba286f52df9575cfe1fbb4fd746bce66fed93dd278f9478d95bad47dccfe7e.png",
    creationTool: "cursor",
    project: "Premium ad formats",
  },
  {
    id: "ac-product-boosting-v2",
    name: "Product Boosting v2",
    path: "/ac/product-boosting-v2",
    description:
      "Exploring advertiser controls for which products get boosted in ad campaigns, building on New Product Boosting.",
    owner: "Arthur Che",
    createdAt: "2026-08-13",
    lastUpdated: "2026-08-13",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/eb085989b64637e0a98947d3ca777349d61cc46e6c408447a7cf307d5388a05f.png",
    creationTool: "claude-code",
  },
  {
    id: "ac-video-ad-tiles-hover-xp",
    name: "Video Ad Tiles Hover XP",
    path: "/ac/video-ad-tiles-hover-xp",
    description:
      "Proposed interaction/behavior for a play-on-hover version of the video tiles in search results XP.",
    owner: "Arthur Che",
    createdAt: "2026-08-14",
    lastUpdated: "2026-08-14",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.faire.com/fastly/8d3c5bf887d8e5dd5bc9a810531507bb7d04991fa67c1894b3316185f29264e9.png",
    creationTool: "claude-code",
    project: "Premium ad formats",
  },
  {
    id: "ac-ad-carousel-on-hubs-exploration",
    name: "Ad Carousel on Hubs - exploration",
    path: "/ac/ad-carousel-on-hubs-exploration",
    description: "Exploring an ad carousel on our category navigation pages.",
    owner: "Arthur Che",
    createdAt: "2026-09-01",
    lastUpdated: "2026-09-15",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "/images/thumbnails/ac-ad-carousel-on-hubs-exploration.png",
    creationTool: "claude-code",
  },
  {
    id: "ac-product-boosting-v-2-m-1",
    name: "Product Boosting v2 - M1",
    path: "/ac/product-boosting-v-2-m-1",
    description:
      "A focused product boosting concept combining specific products, collections, and new-product boosting in Advanced settings.",
    owner: "Arthur Che",
    createdAt: "2026-09-11",
    lastUpdated: "2026-09-11",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    creationTool: "claude-code",
    thumbnail: "/images/thumbnails/ac-product-boosting-v-2-m-1.png",
  },
  {
    id: "ac-ad-carousel-on-hubs-xp-m-1",
    name: "Ad Carousel on Hubs XP - M1",
    path: "/ac/ad-carousel-on-hubs-xp-m-1",
    description:
      "A focused M1 experiment candidate for promoted bestseller carousels on marketplace hubs.",
    owner: "Arthur Che",
    createdAt: "2026-09-15",
    lastUpdated: "2026-09-15",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    creationTool: "claude-code",
    thumbnail: "/images/thumbnails/ac-ad-carousel-on-hubs-xp-m-1.png",
  },
  {
    id: "ac-slideshow-video-assets",
    name: "Slideshow Video Assets",
    path: "/ac/slideshow-video-assets",
    description:
      "Search-results experiment comparing slideshow-only ads (78% slideshow coverage) with video + slideshow (15% video / 60% slideshow, video falling back to slideshow). Slideshows use the first 4 real product images. Autoplay places media from the first ad slot with a 4-ad-slot gap and a cap of 4.",
    owner: "Arthur Che",
    createdAt: "2026-10-01",
    lastUpdated: "2026-10-29",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    creationTool: "cursor",
    project: "Premium ad formats",
    thumbnail: "https://cdn.prerelease.faire.dev/fastly/8b80bf0c2dbc473932728e6064b7c6f16772b9c8be8539eec3038a2e7eeabedb.png",
  },
  {
    id: "ac-reorganize-ads-as-campaigns",
    name: "Reorganize ads as campaigns",
    path: "/ac/reorganize-ads-as-campaigns",
    description:
      "Ads Manager exploration from the Ads Manager Supply Sprint: treat ads as campaigns instead of a flat list of ads.",
    owner: "Arthur Che",
    createdAt: "2026-10-07",
    lastUpdated: "2026-10-07",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    creationTool: "cursor",
    project: "Ads Manager Supply Sprint",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/15dee25911e9bd90e7008bc9baec474f147eb1184b854c654be86436de7f6b10.png",
  },
  {
    id: "ac-brand-ad-carousel-on-hubs",
    name: "Brand Ad Carousel on Hubs",
    path: "/ac/brand-ad-carousel-on-hubs",
    description:
      "A brand-specific shoppable carousel on marketplace hubs: one brand's info plus its bestsellers, in an ad-carousel-sized unit, with a toolbar toggle across eight production brands.",
    owner: "Arthur Che",
    createdAt: "2026-10-09",
    lastUpdated: "2026-10-09",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    creationTool: "cursor",
    project: "Premium ad formats",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/dd999a408a6c3ca5c5fd26c21fdf54ade21fe0cc24c4a0ed9d5f8bf95c318da3.png",
  },
];
